module.exports = __webpack_public_path__ + "img/footer-national-flag.f407ce0.png";